import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import { 
  Logout as LogoutIcon, 
  Business as BusinessIcon, 
  Email as EmailIcon,
  AccountCircle as AccountIcon 
} from '@mui/icons-material'

export default function OrgSwitcher(): React.ReactElement | null {
  const { user, logout } = useAuth()

  if (!user) {
    return null
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 'calc(100% + 8px)',
        right: 0,
        zIndex: 50,
      }}
    >
      <div className="flex items-center space-x-3 bg-white border border-neutral-200 rounded-lg px-3 py-2 shadow-lg hover:shadow-xl transition-all duration-200 backdrop-blur-sm bg-white/95">
      {/* User Info Section - More Compact */}
      <div className="flex items-center space-x-2">
        <div className="w-6 h-6 bg-gradient-to-br from-primary-500 to-primary-700 rounded-full flex items-center justify-center">
          <AccountIcon className="text-white text-xs" />
        </div>
        <div className="flex flex-col">
          <div className="flex items-center space-x-1">
            <BusinessIcon className="text-neutral-500 text-xs" />
            <span className="font-medium text-neutral-900 text-xs">{user.org}</span>
          </div>
          <div className="flex items-center space-x-1">
            <EmailIcon className="text-neutral-400 text-xs" />
            <span className="text-xs text-neutral-600 truncate max-w-24">{user.email}</span>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="h-6 w-px bg-neutral-200"></div>

      {/* Logout Button - More Compact */}
      <button
        onClick={logout}
        className="flex items-center space-x-1 px-2 py-1 text-xs font-medium text-neutral-700 hover:text-error-600 hover:bg-error-50 rounded-md transition-all duration-200 group"
      >
        <LogoutIcon className="text-neutral-500 group-hover:text-error-600 text-xs transition-colors duration-200" />
        <span>Sign Out</span>
      </button>
      </div>
    </div>
  )
} 